import { NavigationTabs, type NavigationTabItem } from '@exam-center/components';
import { APP_PERMISSIONS } from '@exam-center/permission';
import { usePermission } from '@shared/permissions';
import { useMemo } from 'react';

const TAB_ITEMS: NavigationTabItem[] = [
  {
    value: 'Exam Location Details',
    label: 'สถานที่สอบทั้งหมด',
    path: '/admin/exam-location/locations',
    requiredPermission: [
      APP_PERMISSIONS.ADMIN_EXAM_LOCATION_MANAGEMENT.EXAM_LOCATION.VIEW,
      APP_PERMISSIONS.ADMIN_EXAM_LOCATION_MANAGEMENT.EXAM_LOCATION_USAGE.VIEW,
    ],
  },
  {
    value: 'Exam Location Requests',
    label: 'รายการยื่นคำขออนุมัติสถานที่สอบ',
    path: '/admin/exam-location/requests',
    requiredPermission: [
      APP_PERMISSIONS.ADMIN_EXAM_LOCATION_MANAGEMENT.EXAM_LOCATION_REQUEST.VIEW,
      APP_PERMISSIONS.ADMIN_EXAM_LOCATION_MANAGEMENT.EXAM_LOCATION_REQUEST_FIRST_TIER_REVIEW.VIEW,
      APP_PERMISSIONS.ADMIN_EXAM_LOCATION_MANAGEMENT.EXAM_LOCATION_REQUEST_SECOND_TIER_REVIEW.VIEW,
    ],
  },
  // TODO: enable when the feature is ready
  {
    value: 'Exam Location Cancellation',
    label: 'ยกเลิกการใช้งาน',
    path: '/admin/exam-location/cancellations',
    requiredPermission: [
      APP_PERMISSIONS.ADMIN_EXAM_LOCATION_MANAGEMENT.EXAM_LOCATION_CANCELATION.VIEW,
    ],
  },
  {
    value: 'Exam Location Activity Log',
    label: 'Activity Log',
    path: '/admin/exam-location/activity-log',
    requiredPermission: [APP_PERMISSIONS.ADMIN_EXAM_LOCATION_MANAGEMENT.AUDIT_LOG.VIEW],
  },
];

export default function AdminExamLocationManagementNavigationTabs() {
  const { permissions } = usePermission();

  const filteredItems = useMemo(
    () =>
      TAB_ITEMS.filter(({ requiredPermission }) =>
        requiredPermission?.some((permission) => permissions.includes(permission)),
      ),
    [permissions],
  );

  return <NavigationTabs items={filteredItems} />;
}
